module.exports = __webpack_public_path__ + "img/MaskGroup.45568566.png";